/* eslint-disable complexity */
import React from "react";
import PropTypes from "prop-types";

import styles from "./styles.css";
import CARIMG from "./images/carimg.svg";
import FINANCE from "./images/finance.svg";
import NOIMPACT from "./images/no-impact.svg";
import Button from "../../shared/button";
import RIGHTICON from "./images/right.svg";

import { useHistory } from "react-router-dom";
import {  trackDesktopCustomEventsAU  } from "../../../tracking";
import { CAR_LIST_EVENT_NAMES } from "../../../constants/app-constants";
import { makePriceLabelRound } from "../../../au-c2b/utils/helpers/make-price-label";
import Filters from "../../../utils/filters-v2";
import PreApprovedCarCard from "../pre-approved-car-card/component";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import { BOOL_STATE } from "../../../constants/checkout-constants";
import ZeroDepositeFinanceCardRevamp from "../zero-deposit-finance-card-revamp";

const GetPreApproveNewCardInSecondsRevamp = ({
    personalised,
    maxLoanAmount,
    allFilters,
    setPreApprovedOriginConnect,
    updateSelectedSuggestionsConnect,
    updateSelectedOnScreenFilterConnect,
    updateAppliedFiltersConnect,
    updateAppliedSuggestionsConnect,
    updateFilterOptionDataConnect,
    reloadCarListConnect,
    financeData,
    isUserZeroDpVariant,
    isLoggedIn
}) => {
    const NON_PRESONALISED_BENEFITS = [
        {
            key: 1,
            imgSrc: NOIMPACT,
            text: "No impact on credit score"
        },
        {
            key: 2,
            imgSrc: FINANCE,
            text: "User privacy & data confidentiality"
        }

    ];

    const PERSONALISED_BENEFIT = [
        {
            key: 1,
            imgSrc: NOIMPACT,
            text: "No impact on credit score"
        },
        {
            key: 2,
            imgSrc: FINANCE,
            text: "User privacy & data confidentiality"
        }
    ];

    const {loanType} = financeData || {};
    const {isPurposeBusiness} = loanType || {};
    const history = useHistory();
    const handleOnClick = () => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.PRE_APPROVAL_CTA, {
            eventAction: "Get pre approved_buy cars page_pre approval_button",
            eventLabel: "{{Get pre approved button selected from the car listing page}}"
        });
        setPreApprovedOriginConnect(CAR_LIST_EVENT_NAMES.LISTING);
        history.push("/financing/get-pre-approval");
    };

    const applyFilter = () => {
        const data = {
            filterKey: "quotedPrice",
            optionKey: `$0 - ${makePriceLabelRound(maxLoanAmount)}`,
            isSelected: true,
            displayText: `Pre-approved loan limit`,
            isRangeFilter: true,
            rangeValues: {
                min: 0,
                max: maxLoanAmount
            },
            isSingleEntity: true, isSuggestion: true
        };
        updateSelectedOnScreenFilterConnect("");
        updateAppliedFiltersConnect();
        updateAppliedSuggestionsConnect();
        updateSelectedSuggestionsConnect(data);
        updateFilterOptionDataConnect(data);
        reloadCarListConnect(true);
        const filters = new Filters({cityCode: ""});
        const {relativeURL} = filters.getListingPayload({
            selectedFilters: [{
                filterKey: "quotedPrice",
                isRangeFilter: true,
                min: 0,
                max: maxLoanAmount
            }],
            filters: allFilters
        });
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.PRE_APPROVED_LOAN_VIEW_CARS);
        history.replace(relativeURL);
        window.setTimeout(() => {
            window.scrollTo(0, 0);
        });
    };

    const handleFinanceKnowMore = () => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.NUDGES_FINANCE_KNOW_MORE_FINANCE, {
            eventLabel: "CLP"
        });
        history.push("/cars24-finance");
    };

    if (isUserZeroDpVariant && !personalised) {
        return (
            <ZeroDepositeFinanceCardRevamp onClickPreApproval={handleOnClick} />
        );
    }

    return (
        <React.Fragment>
            {personalised  && isPurposeBusiness ===  BOOL_STATE.NO ?
                <PreApprovedCarCard handleApplyFilter={applyFilter} maxLoanAmount={maxLoanAmount}/>
                :
                <div styleName={"styles.container"}>
                    <div styleName={`styles.wrapper ${isLoggedIn ? "styles.loggedInPadding" : "styles.loggedOutPadding"} `}>
                        <img styleName={"styles.carimg"} src={CARIMG} />
                        <div styleName={"styles.head-section"}>
                            {personalised ? <h3 styleName={"styles.heading"}>You're finance< br />pre-approved!<img src={RIGHTICON} /></h3> : <h3 styleName={"styles.heading"}>Get pre-approved< br /><span styleName={"styles.subHeading"}>for used car loan in<br /><span>2 minutes</span></span></h3>}
                        </div>
                        <div styleName={"styles.text-section"}>
                            {
                                (personalised  || isPurposeBusiness ===  BOOL_STATE.YES ? PERSONALISED_BENEFIT : NON_PRESONALISED_BENEFITS).map((item) =>
                                    <p styleName={"styles.text"} key={item.key}><img src={item.imgSrc}/>{item.text}</p>
                                )
                            }
                        </div>
                        {(!personalised || isPurposeBusiness ===  BOOL_STATE.YES) &&
                            <React.Fragment>
                                {!personalised && <div styleName={"styles.button-section"}>
                                    <Button text="Get pre-approval" onClick={handleOnClick}/>
                                </div>}
                                <p styleName={isPurposeBusiness ===  BOOL_STATE.YES ? "styles.knowMore styles.knowMoreCommercial" : "styles.knowMore"} onClick={handleFinanceKnowMore}>Know more about finance</p>
                            </React.Fragment>
                        }
                    </div>
                </div>
            }
        </React.Fragment>
    );
};

GetPreApproveNewCardInSecondsRevamp.propTypes = {
    personalised: PropTypes.bool,
    setPreApprovedOriginConnect: PropTypes.bool,
    maxLoanAmount: PropTypes.number,
    allFilters: PropTypes.object,
    updateSelectedSuggestionsConnect: PropTypes.func,
    updateFilterOptionDataConnect: PropTypes.func,
    reloadCarListConnect: PropTypes.func,
    updateSelectedOnScreenFilterConnect: PropTypes.func,
    updateAppliedFiltersConnect: PropTypes.func,
    updateAppliedSuggestionsConnect: PropTypes.func,
    isUserZeroDpVariant: PropTypes.bool,
    financeData: PropTypes.object,
    isLoggedIn: PropTypes.bool
};

export default GetPreApproveNewCardInSecondsRevamp;
